import apiClient from './apiClient';

/**
 * ═══════════════════════════════════════════════════════════════════════
 * Visit Co-Worker API — Phase 6.0 / 10
 *
 *   POST    /api/organisation/visits/:id/co-workers
 *   DELETE  /api/organisation/visits/:id/co-workers/:memberId
 *   GET     /api/organisation/visits/:id/co-workers
 *
 * Co-workers are peer-equivalent doctors added to a visit by the
 * assigned doctor. They get full write access on the visit
 * (prescription, plan attach, action-pending hops). Stored entirely
 * off the visit row in `org_transactions`.
 * ═══════════════════════════════════════════════════════════════════════
 */
const BASE = '/api/organisation/visits';

export const addCoWorker = async (visitId, memberId) => {
  const { data } = await apiClient.post(`${BASE}/${visitId}/co-workers`, {
    member_id: memberId,
  });
  return data;
};

export const removeCoWorker = async (visitId, memberId) => {
  const { data } = await apiClient.delete(
    `${BASE}/${visitId}/co-workers/${memberId}`,
  );
  return data;
};

export const listCoWorkers = async (visitId) => {
  const { data } = await apiClient.get(`${BASE}/${visitId}/co-workers`);
  return data;  // { co_workers: [...], count }
};

const visitCoworkerApi = { addCoWorker, removeCoWorker, listCoWorkers };
export default visitCoworkerApi;
